import './loading.style.scss';

const Loading = () => {
    return (
        <div className='loader-container'>
            <div class="loader"></div>
        </div>
    )
}

export default Loading;